export default "__VITE_ASSET__BiwlhYgn__"